import { ChangeEvent, useEffect, useState } from 'react';
import { Comment } from '../types';
import { useHighlighting } from '../../Highlighting';

export function useCommentableSearch(comments: Comment[]) {
  const { setHighlighted } = useHighlighting();
  const [query, setQuery] = useState('');
  const [results, setResults] = useState(comments);

  // NOTE: Not efficient, but whatever.
  // TODO: Debounce.
  useEffect(() => {
    if (query) {
      setResults(
        comments.filter((comment) =>
          comment.body
            .replace(/(<([^>]+)>)/gi, '')
            .toLowerCase()
            .includes(query.toLowerCase()),
        ),
      );
    } else {
      setResults(comments);
    }

    setHighlighted(query);
  }, [query, comments, setHighlighted]);

  return {
    query,
    results,
    clearQuery: () => setQuery(''),
    queryChanged(event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) {
      return setQuery(event.target.value);
    },
  };
}
